import React from "react";
import { Icon, IconProps } from "semantic-ui-react";
import { IEvaluationStatics } from "../../../interfaces/IEvaluation";
import "./_EvaluationsSummary.less";

interface EvaluationsSummaryProps {
    data: IEvaluationStatics;
};

export const EvaluationsSummary: React.FC<EvaluationsSummaryProps> = ({ data }) => {

    const totalChecks = data.okay + data.notOkay + data.uknown;


    const renderStatic = (text: string, count: number, iconProps: IconProps) => {
        const rawPercentage = (count / totalChecks * 100);
        const percentage = Math.round(rawPercentage);

        if (isNaN(percentage)) {
            return (
                <div className="EvaluationsSummary-item placeholder" title={text}>
                    <span className="nowrap">
                        <Icon {...iconProps} />
                    </span>
                </div>
            )
        }

        return (
            <div className="EvaluationsSummary-item" title={text}>
                <span className="nowrap">
                    <Icon {...iconProps} />
                    <label> <strong> {percentage}% </strong>  </label>
                </span>
                <small className="nowrap count"> {count} kpl </small>
            </div>
        )
    }

    return (
        <div className="EvaluationsSummary-container">
            {renderStatic("Kunnossa", data.okay, { name: "check", color: "green" })}
            {renderStatic("Korjattavaa", data.notOkay, { name: "times", color: "red" })}
            {data.uknown > 0 && renderStatic("Ei tietoa", data.uknown, { name: "question", color: "grey" })}
        </div>
    );
}
